import { render } from "./DropdownDivider.vue?vue&type=template&id=3dd33280"
const script = {}
script.render = render

export default script